import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function About() {
  return (
    <section data-testid="about-page" className="bg-[#F9FAFB] min-h-screen">
      <Seo
        title="About KNOVAS · Premium Kitchen & Wardrobe Hardware Brand India"
        description="KNOVAS Trading is a premium hardware brand supplying engineered kitchen and wardrobe fittings across India — built for installers, fabricators and modular designers who refuse to compromise."
        path="/about"
      />
      <div className="max-w-[1200px] mx-auto px-6 sm:px-10 lg:px-16 py-24">
        <p className="text-xs tracking-[0.4em] uppercase text-[#FF6A00] mb-6">About</p>
        <h1
          className="text-5xl sm:text-6xl lg:text-7xl font-black uppercase tracking-tight text-[#2B2B2B] leading-[0.9]"
          style={{ fontFamily: "'Anton', sans-serif" }}
        >
          Engineered<br />for the long run.
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mt-16">
          <div>
            <h2 className="text-xs tracking-[0.3em] uppercase text-[#2B2B2B] font-bold border-l-2 border-[#FF6A00] pl-3">Our Standard</h2>
            <p className="mt-6 text-[#4B5563] leading-relaxed">
              KNOVAS is a trading house specialising in premium hardware for kitchens, wardrobes and modern interiors.
              Every series is curated for installers, fabricators and modular designers who refuse to compromise on motion,
              load capacity or finish.
            </p>
            <p className="mt-4 text-[#4B5563] leading-relaxed">
              From whisper-soft hinges to tank-tough sliding mechanisms, our catalogue is built around one promise:
              <span className="text-[#2B2B2B] font-semibold"> Built Strong. Built to Last.</span>
            </p>
          </div>
          <div className="bg-white border border-[#E5E7EB] p-10">
            <h2 className="text-xs tracking-[0.3em] uppercase text-[#2B2B2B] font-bold">Contact</h2>
            <ul className="mt-6 space-y-4 text-sm text-[#4B5563]">
              <li>
                <span className="text-[10px] tracking-[0.3em] uppercase text-[#6B7280] block">Email</span>
                <a href="mailto:knovastrading@gmail.com" data-testid="about-email" className="text-base text-[#2B2B2B] hover:text-[#FF6A00]">knovastrading@gmail.com</a>
              </li>
              <li>
                <span className="text-[10px] tracking-[0.3em] uppercase text-[#6B7280] block">Instagram</span>
                <a href="https://instagram.com/knovas_trading" target="_blank" rel="noopener noreferrer" data-testid="about-instagram" className="text-base text-[#2B2B2B] hover:text-[#FF6A00]">@knovas_trading</a>
              </li>
            </ul>
            <Link
              to="/catalogue"
              data-testid="about-cta-catalogue"
              className="mt-10 inline-flex items-center gap-3 bg-[#FF6A00] hover:bg-[#E65C00] text-white px-6 py-4 text-xs tracking-[0.3em] uppercase font-bold transition-colors"
            >
              Open Catalogue
            </Link>
            <Link
              to="/contact"
              data-testid="about-cta-contact"
              className="mt-4 sm:mt-10 sm:ml-4 inline-flex items-center gap-3 border border-[#2B2B2B] hover:border-[#FF6A00] hover:text-[#FF6A00] text-[#2B2B2B] px-6 py-4 text-xs tracking-[0.3em] uppercase font-bold transition-colors"
            >
              Become a Dealer
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
